module.exports = __webpack_public_path__ + "static/media/Doubts.576a57d8.svg";